<template>
  <v-layout id="screen-log">
    <div>
      <v-navigation-drawer
        ref="drawer"
        permanent
        hide-overlay
        :height="sidebar.height"
        :width="sidebar.width"
      >
        <div class="sidetab-content">
          <v-data-table
            v-if="this.dataSidebarAvailable"
            dense
            class="mr-2 elevation-2"
            multi-sort
            :headers="this.tabSidebar.headers"
            :items="this.tabSidebar.items"
            item-key="id"
            :footer-props="{ 'items-per-page-options': [30, 50, 100, -1] }"
          >
            <template v-slot:top>
              <br />
              <tr>
                <td>
                  <div
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Effacer les filtres"
                  >
                    <v-icon
                      class="fas fa-eraser"
                      v-on:click="clearFilterSidebar"
                    ></v-icon>
                  </div>
                </td>
                <td>
                  <v-layout>
                    <v-text-field
                      v-model="tabSidebar.code_nom_site_depart"
                      type="text"
                      label="Site départ"
                    ></v-text-field>

                    <v-text-field
                      v-model="tabSidebar.code_nom_produit"
                      type="text"
                      label="Produit"
                    ></v-text-field>

                    <v-text-field
                      v-model="tabSidebar.quantite_sortie_min_diff_zero_sup"
                      type="number"
                      label="Quantité >="
                    ></v-text-field>

                    <v-text-field
                      v-model="tabSidebar.quantite_sortie_min_diff_zero_inf"
                      type="number"
                      label="Quantité <="
                    ></v-text-field>
                  </v-layout>
                </td>
              </tr>
              <br />
            </template>
            <template v-slot:item.id="{ item }">
              <v-icon v-on:click="selectItem(item)"
                >{{
                  item.id === tabSidebar.itemSelected.id
                    ? 'fas fa-circle'
                    : 'far fa-circle'
                }}
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </v-navigation-drawer>
    </div>

    <div ref="separator" class="separator">
      <v-icon v-on:click="hideShowSidebar"
        >{{
          sidebar.expanded
            ? 'far fa-caret-square-left'
            : 'far fa-caret-square-right'
        }}
      </v-icon>
    </div>

    <div>
      <v-navigation-drawer
        ref="drawer2"
        permanent
        hide-overlay
        :height="contentright.height"
        :width="contentright.width"
      >
        <div v-if="this.datacontentrightAvailable" class="contentright">
          <v-layout align-end>
            <v-col md="4">
              <h3>
                Site de départ:
                {{ tabSidebar.itemSelected.code_nom_site_depart }}
              </h3>
            </v-col>
            <v-col md="4">
              <h3>Produit: {{ tabSidebar.itemSelected.code_nom_produit }}</h3>
            </v-col>
          </v-layout>
          <v-data-table
            dense
            class="mr-2 elevation-2"
            multi-sort
            :headers="this.tabRight.headers"
            :items="this.tabRight.items"
            item-key="id"
            :options.sync="contentright.options"
            :footer-props="{ 'items-per-page-options': [30, 50, 100, -1] }"
          >
            <template v-slot:top>
              <br />
              <tr>
                <td>
                  <div
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Effacer les filtres"
                  >
                    <v-icon
                      :disabled="toggleDisable"
                      class="fas fa-eraser"
                      v-on:click="clearFilterTabRight"
                    ></v-icon>
                  </div>
                </td>
                <td>
                  <v-layout>
                    <v-text-field
                      v-model="tabRight.ind_depart"
                      :disabled="toggleDisable"
                      type="text"
                      label="Indicateur Départ"
                    ></v-text-field>

                    <v-text-field
                      v-model="tabRight.code_site_arrivee"
                      :disabled="toggleDisable"
                      type="text"
                      label="Code site arrivée"
                    ></v-text-field>

                    <v-text-field
                      v-model="tabRight.nom_site_arrivee"
                      :disabled="toggleDisable"
                      type="text"
                      label="Nom site arrivée"
                    ></v-text-field>

                    <v-text-field
                      v-model="tabRight.ind_arrivee"
                      :disabled="toggleDisable"
                      type="text"
                      label="Indicateur arrivée"
                    ></v-text-field>

                    <v-text-field
                      v-model="tabRight.prix_transportInf"
                      :disabled="toggleDisable"
                      type="number"
                      label="Prix du transport >="
                    ></v-text-field>

                    <v-text-field
                      v-model="tabRight.prix_transportSup"
                      :disabled="toggleDisable"
                      type="number"
                      label="Prix du transport <="
                    ></v-text-field>

                    <v-select
                      v-model="tabRight.instant"
                      :disabled="toggleDisable"
                      :items="tabRight.instantChoice"
                      label="Choix instant"
                      multiple
                    ></v-select>

                    <v-text-field
                      v-model="tabRight.moyen"
                      :disabled="toggleDisable"
                      type="text"
                      label="Moyen de transport"
                    ></v-text-field>

                    <v-select
                      v-model="tabRight.humide"
                      :disabled="toggleDisable"
                      :items="tabRight.humideChoice"
                      item-text="cle"
                      item-value="valeur"
                      label="Produit humide"
                      multiple
                    ></v-select>

                    <v-text-field
                      v-model="tabRight.quantiteeSup"
                      :disabled="toggleDisable"
                      type="number"
                      label="Quantité >="
                    ></v-text-field>

                    <v-text-field
                      v-model="tabRight.quantiteeInf"
                      :disabled="toggleDisable"
                      type="number"
                      label="Quantité <="
                    ></v-text-field>

                    <v-select
                      v-model="tabRight.editee"
                      :disabled="toggleDisable"
                      :items="tabRight.editeeChoice"
                      item-text="cle"
                      item-value="valeur"
                      label="Choix éditée ou non"
                      multiple
                    ></v-select>
                  </v-layout>
                </td>
              </tr>
              <br />
            </template>
            <template v-slot:item.humide="{ item }">
              {{ item.humide == 1 ? 'Oui' : 'Non' }}
            </template>
            <template v-slot:item.edite="{ item }">
              <v-icon v-on:click="resetModif(item)">
                {{ item.edite == 1 ? 'fas fa-undo' : '' }}
              </v-icon>
            </template>
            <template
              v-bind:class="{ noWidth: noWidth }"
              v-slot:item.quantiteTmp="{ item }"
            >
            </template>
            <template v-slot:item.quantite="props">
              <v-edit-dialog
                class="dialog"
                cancel-text="annuler"
                save-text="sauvegarder"
                @save="saveEditQuantite(props.item)"
                @cancel="cancelEditQuantite(props.item)"
                @open="onOpen(props.item)"
                large
                persistent
              >
                <div>{{ props.item.quantite }}</div>
                <template v-slot:input>
                  <div class="mt-4 title">Modifier quantité</div>
                  <v-text-field
                    v-model="props.item.quantite"
                    :rules="[rules.pattern]"
                    label="Modifier"
                    single-line
                    autofocus
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
          </v-data-table>
          <v-btn
            class="mr-2 scdf-yellow"
            @click="sendModifiation(tabRight.outData)"
          >
            APPLIQUER LES MODIFICATIONS
          </v-btn>
        </div>
        <div v-else>
          <v-overlay :opacity="0.1"
            ><div v-if="displaySuggestion" class="choice-message">
              Veuillez sélectionner une entrée sur le panneau de gauche
            </div></v-overlay
          >
        </div>
      </v-navigation-drawer>
    </div>

    <div v-if="this.processing || this.processingSiteProduit">
      <v-overlay :z-index="zIndex" :value="overlay"
        ><spinner
          class="spinner-tab"
          :message="messageSpinner"
          :displayInfos="false"
      /></v-overlay>
    </div>
  </v-layout>
</template>

<script>
import Spinner from '@/components/AppSpinner';
export default {
  components: {
    Spinner,
  },
  props: ['user'],
  data: function () {
    return {
      windowsModifOpen: 0,
      toggleDisable: false,
      displaySuggestion: false,
      processing: false,
      processingSiteProduit: false,
      documentHeight: 0,
      documentWidth: 0,
      messageSpinner: '',
      overlay: true,
      rules: {
        pattern: (v) => {
          const pattern = /^(\d+(?:[\.]\d{1,2})?)$/;
          return (
            pattern.test(v) ||
            'Doit contenir un entier ou un décimal avec un point en séparateur et 1 ou 2 chiffres après'
          );
        },
      },
      zIndex: 9999,
      dataSidebarAvailable: false,
      datacontentrightAvailable: false,
      el: null,
      sidebarElement: null,
      itemsRigthWatch: [],
      sidebar: {
        expanded: true,
        width: 0,
        maxWidth: 0,
        height: 0,
        sidebarWidthTmp: 0,
      },
      contentright: {
        width: 0,
        height: 0,
      },
      tabRight: {
        initialValues: [],
        outData: [],
        editquantite: [],
        items: [],
        moyen: '',
        humide: [],
        instant: [],
        quantiteeSup: '',
        quantiteeInf: '',
        ind_depart: '',
        nom_site_arrivee: '',
        code_site_arrivee: '',
        ind_arrivee: '',
        prix_transportSup: '',
        prix_transportInf: '',
        editee: [],
        humideChoice: [],
        instantChoice: [],
        editeeChoice: [],
        headers: [
          {
            text: 'Indicateur Départ',
            value: 'ind_depart',
            align: 'center',
            filter: (f) => {
              return (f + '')
                .toLowerCase()
                .includes(this.tabRight.ind_depart.toLowerCase());
            },
          },
          {
            text: 'Code Site arrivée',
            value: 'code_site_arrivee',
            align: 'center',
            filter: (f) => {
              return (f + '')
                .toLowerCase()
                .includes(this.tabRight.code_site_arrivee.toLowerCase());
            },
          },
          {
            text: 'Nom Site arrivée',
            value: 'nom_site_arrivee',
            align: 'center',
            filter: (f) => {
              return (f + '')
                .toLowerCase()
                .includes(
                  this.tabRight.nom_site_arrivee
                    .replaceAll(' ', '_')
                    .toLowerCase()
                );
            },
          },
          {
            text: 'Indicateur arrivée',
            value: 'ind_arrivee',
            align: 'center',
            filter: (f) => {
              return (f + '')
                .toLowerCase()
                .includes(this.tabRight.ind_arrivee.toLowerCase());
            },
          },
          {
            text: 'Prix de transport',
            value: 'prix_transport',
            align: 'center',
            filter: (f) => {
              return (
                f >= this.tabRight.prix_transportInf &&
                (this.tabRight.prix_transportSup == 0
                  ? true
                  : f <= this.tabRight.prix_transportSup)
              );
            },
          },
          {
            text: 'Instant',
            value: 'instant',
            align: 'center',
            filter: (o) => {
              return this.tabRight.instant.length == 0
                ? true
                : this.tabRight.instant.includes(o);
            },
          },
          {
            text: 'Moyen de transport',
            value: 'moyen',
            align: 'center',
            filter: (f) => {
              return (f + '')
                .toLowerCase()
                .includes(this.tabRight.moyen.toLowerCase());
            },
          },
          {
            text: 'Produit humide',
            value: 'humide',
            align: 'center',
            filter: (o) => {
              return this.tabRight.humide.length == 0
                ? true
                : this.tabRight.humide.includes(o);
            },
          },
          {
            text: 'Quantité',
            value: 'quantite',
            align: 'center',
          },
          {
            text: 'Editée',
            value: 'edite',
            align: 'center',
            filter: (o) => {
              return this.tabRight.editee.length == 0
                ? true
                : this.tabRight.editee.includes(o);
            },
          },
          {
            value: 'quantiteTmp',
            align: 'center',
            sortable: false,
            width: 0,
            filter: (value) => {
              return (
                value >= this.tabRight.quantiteeSup &&
                (this.tabRight.quantiteeInf == ''
                  ? true
                  : value <= this.tabRight.quantiteeInf)
              );
            },
          },
        ],
      },
      tabSidebar: {
        itemSelected: {
          id: '',
          idproduit: -1,
          idsite_depart: -1,
          code_nom_produit: '',
          code_nom_site_depart: '',
        },
        items: [],
        code_nom_site_depart: '',
        code_nom_produit: '',
        quantite_sortie_min_diff_zero_sup: '',
        quantite_sortie_min_diff_zero_inf: '',
        headers: [
          {
            text: 'Site départ',
            value: 'code_nom_site_depart',
            align: 'center',
            filter: (f) => {
              return (f + '')
                .toLowerCase()
                .includes(
                  this.tabSidebar.code_nom_site_depart
                    .replaceAll(' ', '_')
                    .toLowerCase()
                );
            },
          },
          {
            text: 'Produit',
            value: 'code_nom_produit',
            align: 'center',
            filter: (f) => {
              return (f + '')
                .toLowerCase()
                .includes(
                  this.tabSidebar.code_nom_produit
                    .replaceAll(' ', '_')
                    .toLowerCase()
                );
            },
          },

          {
            text: 'Quantité minimale sortante',
            value: 'quantite_sortie_min_diff_zero',
            align: 'center',
            filter: (value) => {
              return (
                value >= this.tabSidebar.quantite_sortie_min_diff_zero_sup &&
                (this.tabSidebar.quantite_sortie_min_diff_zero_inf == ''
                  ? true
                  : value <= this.tabSidebar.quantite_sortie_min_diff_zero_inf)
              );
            },
          },
          {
            text: '',
            value: 'id',
            align: 'center',
            sortable: false,
          },
        ],
      },
    };
  },
  methods: {
    async sendModifiation(array) {
      this.processing = true;
      this.datacontentrightAvailable = false;
      this.messageSpinner = 'Prise en compte de vos modifications en cours';
      let json = JSON.stringify(array);
      let flagError = false;
      let flagStatus;
      await axios({
        method: 'post',
        url:
          process.env.VUE_APP_BASE_URL +
          process.env.VUE_APP_MODIF_MODIF_TRANSFERT,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
        data: {
          jsonIn: json,
        },
      })
        .then((response) => {
          flagStatus = response.data.status;
          this.$emit(
            'message-response',
            response.data.message,
            response.data.status,
            true,
            600000
          );
        })
        .catch((error) => {
          flagError = true;
          this.$emit(
            'message-response',
            'Erreur du serveur lors de la modification des données',
            -1,
            true,
            9000
          );
          this.selectItem(this.tabSidebar.itemSelected);
        });

      if (!flagError && flagStatus == 1) {
        this.clearFilterSidebar();
        await this.getClientProduit();
      }

      let itemAvailable = false;
      this.tabSidebar.items.forEach((item) => {
        if (this.tabSidebar.itemSelected.id == item.id) {
          itemAvailable = true;
          this.tabSidebar.itemSelected = item;
        }
      });

      if (itemAvailable) {
        this.selectItem(this.tabSidebar.itemSelected);
      } else {
        this.tabSidebar.itemSelected.id = '';
      }

      this.processing = false;
    },
    resetModif(item) {
      this.deleteEloutData(item.id);
      item.edite = 0;
      this.tabRight.initialValues.forEach((element) => {
        if (element.id == item.id) {
          item.quantite = element.quantite;
          item.quantiteTmp = element.quantite;
        }
      });
    },
    onOpen(item) {
      var oldItem = {
        id: item.id,
        quantite: item.quantite,
      };
      this.tabRight.editquantite.push(oldItem);
      this.windowsModifOpen++;
    },
    validateData(v) {
      const pattern = /^([0-9]+(?:[\.][0-9]{1,2})?)$/;
      return pattern.test(v) && !!v;
    },
    valueInvalid(item) {
      this.tabRight.editquantite.forEach((element) => {
        if (element.id == item.id) {
          item.quantite = element.quantite;
        }
      });
      var filtered = this.tabRight.editquantite.filter(function (
        el,
        index,
        arr
      ) {
        return el.id != item.id;
      });
      this.tabRight.editquantite = filtered;
    },
    cancelEditQuantite(item) {
      this.valueInvalid(item);
      this.windowsModifOpen--;
    },
    pushOutData(item) {
      var delta = 0;

      this.tabRight.initialValues.forEach((element) => {
        if (element.id == item.id) {
          delta = item.quantite - element.quantite;
          delta = delta.toFixed(2);
        }
      });
      this.tabRight.outData.forEach((element) => {
        if (item.id == element.id) {
          this.deleteEloutData(item.id);
        }
      });
      if (delta != 0) {
        var tosave = {
          id: item.id,
          delta: delta,
        };
        this.tabRight.outData.push(tosave);
      }
    },
    deleteEloutData(id) {
      var filtered = this.tabRight.outData.filter(function (el, i, a) {
        return el.id != id;
      });
      this.tabRight.outData = filtered;
    },
    saveEditQuantite(item) {
      if (this.validateData(item.quantite) || item.quantite == 0) {
        item.edite = 1;
        //put outData
        this.pushOutData(item);
        item.quantiteTmp = item.quantite;
        var filtered = this.tabRight.editquantite.filter(function (
          el,
          index,
          arr
        ) {
          return el.id != item.id;
        });
        this.tabRight.editquantite = filtered;
      } else {
        item.edite = 0;
        this.valueInvalid(item);
      }

      this.tabRight.initialValues.forEach((element) => {
        if (element.id == item.id) {
          if (element.quantite == item.quantite) {
            item.edite = 0;
            //TODO flush outData
          }
        }
      });
      this.windowsModifOpen--;
    },
    async selectItem(item) {
      this.datacontentrightAvailable = false;
      this.processing = true;
      this.messageSpinner = 'Chargement données du tableau';
      this.tabSidebar.itemSelected = item;
      this.displaySuggestion = false;
      this.tabRight.editquantite = [];
      this.tabRight.initialValues = [];
      this.tabRight.outData = [];
      axios({
        method: 'get',
        url:
          process.env.VUE_APP_BASE_URL +
          process.env.VUE_APP_MODIF_GET_TRANSFERT,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
        params: {
          siteId: item.idsite_depart,
          produitId: item.idproduit,
        },
      })
        .then((response) => {
          this.tabRight.items = response.data.data;
          this.itemsRigthWatch = response.data.data;

          this.tabRight.items.forEach((element) => {
            var o = {
              id: element.id,
              quantite: element.quantite,
            };
            this.tabRight.initialValues.push(o);
          });
          this.datacontentrightAvailable = true;
          this.processing = false;
        })
        .catch((error) => {
          this.processing = false;
          this.$emit(
            'message-response',
            'Erreur serveur lors du chargement des données du panneau droit',
            -1,
            true,
            9000
          );
          this.datacontentrightAvailable = true;
        })
        .finally(() => {
          this.clearFilterTabRight();
        });
    },
    onWindowsResize(e) {
      this.updateConstantes();
    },
    hideShowSidebar() {
      this.sidebar.expanded = !this.sidebar.expanded;
      if (!this.sidebar.expanded) {
        this.sidebar.width = 0;
      } else {
        this.sidebar.width = this.sidebar.sidebarWidthTmp;
      }
    },
    resize(e) {
      if (e.clientX < this.maxWidth) {
        document.body.style.cursor = 'ew-resize';
        this.sidebarElement.style.width = e.clientX + 'px';
        this.contentright.width = this.documentWidth - e.clientX - 60;
      }
    },
    setBorderWidth() {
      this.el.style.cursor = 'ew-resize';
      this.el.style.backgroundColor = 'orange';
      var rect = this.el.getBoundingClientRect();
      this.sidebar.height =
        this.documentHeight - rect.top - this.documentHeight / 20;
    },
    updateConstantes() {
      this.documentWidth = window.innerWidth;
      this.documentHeight = window.innerHeight;
      this.sidebar.sidebarWidthTmp = this.documentWidth / 3;
      this.maxWidth = this.documentWidth / 2;
      this.contentright.width = this.documentWidth - 60 - this.sidebar.width;
    },
    setConstantes() {
      this.documentWidth = window.innerWidth;
      this.documentHeight = window.innerHeight;
      this.el = this.$refs['separator'];
      this.sidebarElement = this.$refs.drawer.$el;
      this.sidebar.sidebarWidthTmp = this.documentWidth / 3;
      this.maxWidth = this.documentWidth / 2;
      this.contentright.width =
        this.documentWidth - 60 - this.sidebar.sidebarWidthTmp;
    },
    setEvents() {
      const sidebar = this.$refs.drawer.$el;
      const contentelement = this.$refs.drawer2.$el;
      const el = this.$refs['separator'];

      window.addEventListener('resize', this.onWindowsResize);

      el.addEventListener(
        'mousedown',
        (e) => {
          if (this.sidebar.expanded !== false) {
            el.style.transition = 'initial';
            sidebar.style.transition = 'initial';
            contentelement.style.transition = 'initial';
            document.addEventListener('mousemove', this.resize, true);
          }
        },
        false
      );
      document.addEventListener(
        'mouseup',
        (e) => {
          el.style.transition = '';
          sidebar.style.transition = '';
          contentelement.style.transition = '';
          document.body.style.cursor = '';
          document.removeEventListener('mousemove', this.resize, true);
        },
        false
      );
    },
    waitResolveSeconds(sec) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve('resolved');
        }, sec * 1000);
      });
    },
    displaySuggestionFunc() {
      if (this.tabSidebar.itemSelected.id == '') {
        this.displaySuggestion = true;
      }
    },
    async getClientProduit() {
      this.processingSiteProduit = true;
      this.messageSpinner = 'Chargement données panneau latéral';
      this.dataSidebarAvailable = false;
      axios({
        method: 'get',
        url:
          process.env.VUE_APP_BASE_URL +
          process.env.VUE_APP_MODIF_GET_SITE_PRODUIT,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
      })
        .then((response) => {
          this.processingSiteProduit = false;
          this.tabSidebar.items = response.data.data;
          this.dataSidebarAvailable = true;
        })
        .catch((error) => {
          this.tabSidebar.items = [];
          this.processingSiteProduit = false;
          this.$emit(
            'message-response',
            'Erreur serveur lors du chargement des données du panneau latéral',
            -1,
            true,
            9000
          );
          this.dataSidebarAvailable = true;
        })
        .finally(() => {
          this.displaySuggestionFunc();
        });
    },
    clearFilterSidebar() {
      this.tabSidebar.code_nom_site_depart = '';
      this.tabSidebar.code_nom_produit = '';
      this.tabSidebar.quantite_sortie_min_diff_zero_sup = '';
      this.tabSidebar.quantite_sortie_min_diff_zero_inf = '';
    },
    clearFilterTabRight() {
      this.tabRight.moyen = '';
      this.tabRight.humide = [];
      this.tabRight.instant = [];
      this.tabRight.quantiteeSup = '';
      this.tabRight.quantiteeInf = '';
      this.tabRight.prix_transportSup = '';
      this.tabRight.prix_transportInf = '';
      this.tabRight.ind_depart = '';
      this.tabRight.nom_site_arrivee = '';
      this.tabRight.code_site_arrivee = '';
      this.tabRight.ind_arrivee = '';
      this.tabRight.editee = [];
    },
  },
  watch: {
    windowsModifOpen: function () {
      if (this.windowsModifOpen > 0) {
        this.toggleDisable = true;
      } else {
        this.toggleDisable = false;
      }
    },
    dataSidebarAvailable: function () {
      this.sidebar.width = this.sidebar.sidebarWidthTmp;
    },
    documentWidth: function () {
      this.sidebar.expanded = true;
      this.sidebar.width = this.sidebar.sidebarWidthTmp;
    },
    documentHeight: function () {
      this.sidebar.expanded = true;
      var rect = this.el.getBoundingClientRect();
      this.sidebar.height =
        this.documentHeight - rect.top - this.documentHeight / 20;
      this.contentright.height =
        this.documentHeight - rect.top - this.documentHeight / 20;
    },
    itemsRigthWatch: function () {
      this.tabRight.items.forEach((element) => {
        if (!this.tabRight.instantChoice.includes(element.instant)) {
          this.tabRight.instantChoice.push(element.instant);
        }
      });
      this.tabRight.humideChoice.push(
        { cle: 'Oui', valeur: 1 },
        { cle: 'Non', valeur: 0 }
      );
      this.tabRight.editeeChoice.push(
        { cle: 'Oui', valeur: 1 },
        { cle: 'Non', valeur: 0 }
      );
    },
  },
  mounted() {
    this.setConstantes();
    this.setBorderWidth();
    this.setEvents();
  },
  created() {
    this.getClientProduit();
  },
};
</script>

<style>
.noWidth {
  width: 0;
}

.scdf-yellow {
  margin-top: 10px;
}

.spinner-tab {
  margin-top: 30px;
}

.v-text-field {
  padding-right: 10px;
}

.contentright {
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 10px;
}

.sidetab-content {
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 10px;
}

.choice-message {
  color: black;
}

.dialog {
  z-index: 99999;
}
</style>